import { checkWalletForOrderApiCall, getUserOrdersApiRequest, payOrderWithWalletApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const GET_USER_ORDERS = { entity: 'GET_USER_ORDERS', action: Action.GET_MANY };
export const CHECK_WALLET_FOR_ORDER = { entity: 'CHECK_WALLET_FOR_ORDER', action: Action.GET_ONE };
export const PAY_ORDER_WITH_WALLET = { entity: 'PAY_ORDER_WITH_WALLET', action: Action.POST };

export const getUserOrders = (userId, customerId) => async dispatch =>
  execute(dispatch, () => getUserOrdersApiRequest(userId, customerId), GET_USER_ORDERS, false);

export const checkWalletForOrder = orderId => async dispatch =>
  execute(dispatch, () => checkWalletForOrderApiCall({ orderId }), CHECK_WALLET_FOR_ORDER, false, { orderId });

export const payOrderWithWallet = orderId => async dispatch =>
  execute(dispatch, () => payOrderWithWalletApiCall({ orderId }), PAY_ORDER_WITH_WALLET, true);

export const orderReducers = {
  userOrders: basicReducer(GET_USER_ORDERS),
  checkWalletForOrder: basicReducer(CHECK_WALLET_FOR_ORDER),
  payOrderWithWallet: basicReducer(PAY_ORDER_WITH_WALLET),
};
